import React from 'react';

interface AlertMessageProps {
  message: string;
  type?: 'success' | 'error' | 'info';
}

const AlertMessage: React.FC<AlertMessageProps> = ({ message, type = 'info' }) => {
  const alertStyles = {
    success: 'bg-green-50 text-green-800 border-green-200',
    error: 'bg-red-50 text-red-800 border-red-200',
    info: 'bg-blue-50 text-blue-800 border-blue-200'
  };
  
  return (
    <div className={`p-4 mb-4 rounded-lg border text-center ${alertStyles[type]} text-sm`}>
      {message}
    </div>
  );
};

export default AlertMessage;
